export default __webpack_public_path__ + "737dedc32b59205a84d9a692a4d0493f.woff2";